module.exports = {
  siteUrl: 'https://fielcode.com', // Domain of your website without pathPrefix.
  siteLogo: '/logos/logo-rnpro-600x315.png', // Logo used for SEO and manifest.
  siteFBAppID: '361957944208361', // FB Application ID for using app insights
  siteGATrackingID: 'UA-120795182-1', // Tracking code ID for google analytics.
  userTwitter: '', // Optionally renders "Follow Me" in the UserInfo segment.
}



// WEBPACK FOOTER //
// ./data/SiteConfig.js